import PoetAllInfoTimeLine from './PoetAllInfoTimeLine.jsx';

import './timeline-media.scss';

export default PoetAllInfoTimeLine;
